// Shared sign-out helpers used by both the manual Logout screen and the global
// 401 handler in axios.js. Kept dependency-free (no service imports) so it can
// be pulled into the axios module without creating a circular import.

// sessionStorage key carrying a one-shot message to show on the login screen
// after an involuntary logout (e.g. a 401 "school blocked" response).
export const FORCED_LOGOUT_MESSAGE_KEY = "forcedLogoutMessage";

// localStorage keys that must survive a sign-out. Only per-device recording
// metadata is preserved (its audio blobs live in IndexedDB and are not backed
// by the announcements API). Mirrors PRESERVED_KEYS in Logout.js — kept as a
// literal here to avoid importing AnnouncementStorageUtils (and, through it,
// axios) into the axios module graph. See ANNOUNCEMENT_RECORDINGS_META_KEY.
const PRESERVED_KEYS = ["announcementRecordings"];

// Wipe all auth/session state: clear sessionStorage and localStorage while
// restoring the preserved keys. Everything else (token, userInfo, scheduler
// bookkeeping, offline sync queue) is dropped.
export function clearSession() {
    const preserved = PRESERVED_KEYS.map((key) => [key, localStorage.getItem(key)]);

    try {
        sessionStorage.clear();
    } catch (e) {
        // ignore — storage may be unavailable (private mode, etc.)
    }
    localStorage.clear();

    preserved.forEach(([key, value]) => {
        if (value !== null) {
            localStorage.setItem(key, value);
        }
    });
}

// Involuntary logout: clear the session, stash an optional message for the
// login screen, and send the user to sign-in. Safe to call from anywhere.
export function forceLogout(message) {
    clearSession();

    if (message) {
        try {
            sessionStorage.setItem(FORCED_LOGOUT_MESSAGE_KEY, message);
        } catch (e) {
            // ignore — the redirect still happens without the banner message
        }
    }

    window.location.href = "/#/auth/signin";
}
